function IdGenerator() {
  let id = 0;
  return () => {
    id += 1;
    return `UniqueId-${id}`;
  };
}

const getUniqueId = new IdGenerator();

export default getUniqueId;
